export const contextBizctxUpdatedMock = {
  contactId: 887888,
  companyId: 5226,
  region: 'US',
  patientId: '59e7eb1c-2215-49bd-9588-7829e94a1be1',
  orderId: 138378943,
  csmMessageId: '',
  rxId: '95a452ec-d06e-4a9f-9ad7-2d32543106fb',
};
